import Swiper, { Navigation, Lazy, Pagination, EffectFade } from "swiper";
import GallerySimple from '../blocks/gallery-simple';
import Gallery from '../blocks/gallery';
import GalleryVideo from '../blocks/gallery-video';


const templateServices = {
  init() {
    new GallerySimple('.gallery-simple');
    new Gallery('.gallery');
    new GalleryVideo('.gallery-video');
    templateServices.gridItemsAdvancedSlider();
  },

  gridItemsAdvancedSlider() {
    const cardsSwiperEl = $(".services-advanced");
    if (!cardsSwiperEl.length) {
      return;
    }

    if (cardsSwiperEl.length) {

      new Swiper(cardsSwiperEl.find(".swiper")[0], {
        modules: [Lazy, Pagination],
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: {
          el: cardsSwiperEl.find(".swiper-pagination"),
          type: "bullets",
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
      });
    }
  },
}
export default templateServices;
